import { render, staticRenderFns } from "./OrdersManageNav.vue?vue&type=template&id=464e38ba&"
import script from "./OrdersManageNav.vue?vue&type=script&lang=js&"
export * from "./OrdersManageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports